<template>
  <div>
    <PageHeader :title="title" :items="items"/>
    <remaining class="text-end" :total="total" :used="used"></remaining>

    <b-row align-h="center">
      <b-col sm="12" md="12" xl="9" lg="12">
        <div>

          <div class="text-center">
            <div class="mt-4 mb-4 d-flex justify-content-center">
              <h1 class="col-sm-8 d-block page-title">
                {{ $t('pages.keyword.index.title') }}
              </h1>
            </div>
          </div>

          <div class="mb-5">
            <keyword-component @search="handleSearch" :loading="loading" :disabled="disabledQuota"/>
            <div id="dropdown-boundry" style="height: 120px" v-if="!keywords && !loading"></div>
          </div>

          <b-card no-body v-if="keywordList.length > 0">
            <b-card-body class="pb-1 pt-2">
              <b-row align-content="between" align-v="center">
                <b-col sm="10">
                  <div class="d-flex" style="flex-wrap: wrap">
                    <keyword-chip v-for="keyword in keywordList" :key="keyword" :keyword="keyword"></keyword-chip>
                  </div>
                </b-col>
                <b-col sm="2" class="text-end">
                  <b-btn size="sm" variant="danger" @click="showTitleGenerator" v-if="titleGeneratorActive">
                    <i class="mdi mdi-creation"></i>
                    {{ $t('pages.keyword.index.title_generator') }}
                  </b-btn>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>

          <b-card no-body v-if="loading || keywords">
            <b-card-body v-if="keywords && !loading" class="p-0">
              <keyword-table :keywords="keywords" :keyword="keyword"></keyword-table>
            </b-card-body>
            <b-card-body v-if="loading">
              <b-skeleton-table
                  :rows="10"
                  :columns="4"
                  :table-props="{ bordered: true, striped: true }"
              ></b-skeleton-table>
            </b-card-body>
          </b-card>
        </div>
      </b-col>
      <title-generator-modal v-if="titleGeneratorActive" :options="flatKeywords"/>
    </b-row>
  </div>
</template>

<script>
import KeywordTable from "./Components/KeywordTable";
import KeywordService from "../../../Services/Api/KeywordService";
import KeywordComponent from "./Components/KeywordComponent";
import KeywordChip from "./Components/Widget/KeywordChip";
import TitleGeneratorModal from "./Components/TitleGeneratorModal";
import {keywordComputed, keywordMethods} from "@/state/helpers";
import QuotaMixin from "../../../mixins/QuotaMixin";

export default {
  name: "Index",
  components: {
    TitleGeneratorModal,
    KeywordChip,
    KeywordComponent,
    KeywordTable
  },
  mixins: [QuotaMixin],
  page() {
    return {
      title: this.$t('pages.keyword.index.main_title'),
      meta: [
        {
          name: "description",
          content: this.$t('common.app_title')
        }
      ]
    }
  },
  data() {
    return {
      title: this.$t('pages.keyword.index.main_title'),
      items: [
        {
          text: this.$t('pages.keyword.index.items.first'),
          href: "/",
        },
        {
          text: this.$t('pages.keyword.index.items.second'),
          active: true,
        },
      ],
      keywords: null,
      loading: false,
      keyword: '',
      flatKeywords: [],
      languageCode: 'en',
      quotaType: 'keyword_research',
    }
  },
  computed: {
    ...keywordComputed,
    titleGeneratorActive() {
      return this.languageCode === 'en'
    }
  },
  methods: {
    ...keywordMethods,
    async handleSearch(e) {
      this.loading = true
      this.keyword = e.keyword
      this.languageCode = e.language_code

      this.keywords = []
      this.flatKeywords = []

      this.clearKeywords()

      const payload = {
        'marketplace_id': e.marketplace_id,
        'keyword': this.keyword,
        "location_code": e.location_code,
        "language_code": this.languageCode
      }

      const {data: keywords} = await KeywordService.store({payload}).finally(() => {
        this.loading = false
      })

      this.getSubscriptionQuota()

      for (let i = 0; i < keywords.data.suggestions.length; i++) {
        if (keywords.data.suggestions[i].value === `${this.keyword} `) {
          keywords.data.suggestions.splice(i, 1)
        } else {
          this.flatKeywords.push(keywords.data.suggestions[i].value)
        }
      }

      this.keywords = keywords.data
    },
    showTitleGenerator() {
      this.$bvModal.show('title-generator-modal')
    }
  },
  destroyed() {
    this.clearKeywords()
  }
}
</script>

<style scoped>
.page-title {
  font-size: 3rem;
  font-weight: 700
}

/deep/ .card {
  border-radius: 16px !important;
}

@media (max-width: 768px) {
  /deep/ .card {
    border-radius: 6px !important;
  }
}


</style>